<template>
    <div class="main">
        <div class="admin-section">
            <div class="container">
                <div class="row">
                    <h1 class="section-heading col-12">Edit "Contacts"</h1>
                    <b-table id="contacts-table" 
                             :busy="loading"
                             :items="sortedItems"
                             :fields="fields">
                        <template #cell(edit)="row">
                            <b-button size="sm" @click="deleteItem(row.item)" class="mr-2 delete-button">
                                Delete
                            </b-button>
                            <b-button size="sm" @click="editItem(row.item)" class="mr-2 edit-button">
                                Edit
                            </b-button>
                        </template>
                        <template #cell(telephone)="row">
                             <p v-for="phone in row.item.telephone" v-bind:key="phone">T: {{phone}}</p>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="buttons-container float-right">
                    <b-button @click="onAddNew" class="submit-button">Add new office</b-button>
                </div>
            </div>
        </div>

        <b-modal ref="editPopup"
                 :no-close-on-backdrop="true"
                 title="Edit office contacts"
                 @close="onPopupClose"
                 @ok="onEditSave"
                 @cancel="onPopupCancel"
                 size="lg">
            <b-overlay :show="updating">
                <form v-if="item">
                    <b-form-group label="Name:"
                                    label-for="name"
                                    invalid-feedback="Office name is required. Enter at least 2 letters."
                                    :state="nameState"
                                    label-cols="2">
                        <b-form-input id="name"
                                    v-model="item.name"
                                    required
                                    :state="nameState"
                                    :disabled="item.name === 'Singapore' ? true : false"
                                    size="sm"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Adress:"
                                    label-for="address1"
                                    invalid-feedback="Office address is required. Enter at least 2 rows."
                                    :state="addressState"
                                    label-cols="2">
                        <b-input-group>
                            <b-form-input id="address1"
                                        v-model="item.address[0]"
                                        required
                                        :state="addressState"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm"
                                            @click="addNewLine('address')" 
                                            class="mr-2 edit-button">
                                    Add line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group v-for="(line, i) in item.address" v-bind:key="line + i" class="array-input">
                            <b-form-input v-if="i > 0"
                                        aria-label="address"
                                        :value="item.address[i]"
                                        @input="item.address[i] = $event"
                                        :required="i === 0 ? 'required' : false"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append v-if="i > 0">
                                <b-button size="sm"
                                            @click="removeLine('address', i)" 
                                            class="mr-2 delete-button">
                                    Remove line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="!!item.telephone"
                                    label="Phones:"
                                    label-for="phone1"
                                    label-cols="2">
                        <b-input-group>
                            <b-form-input id="phone1"
                                        v-model="item.telephone[0]"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm"
                                    @click="addNewLine('telephone')" 
                                    class="mr-2 edit-button">
                                    Add line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group v-for="(phone, i) in item.telephone" v-bind:key="phone + i" class="array-input">
                            <b-form-input v-if="i > 0"
                                        aria-label="phone"
                                        :value="item.telephone[i]"
                                        @input="item.telephone[i] = $event"
                                        class="array-input"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append v-if="i > 0">
                                <b-button size="sm"
                                            @click="removeLine('telephone', i)" 
                                            class="mr-2 delete-button">
                                    Remove line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Fax:"
                                    label-for="fax"
                                    label-cols="2">
                        <b-form-input id="fax"
                                    v-model="item.fax"
                                    size="sm"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="item.name === 'Singapore'"
                                    label="Chartering emails:"
                                    label-for="chartering"
                                    invalid-feedback="At least one chartering email is required. Provide latitude and longitude as coma separated values."
                                    :state="charteringState"
                                    label-cols="2">
                        <b-input-group>
                            <b-form-input id="chartering"
                                        v-model="item.mails.chartering[0]"
                                        required
                                        :state="charteringState"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm"
                                            @click="addNewMailsLine('chartering')" 
                                            class="mr-2 edit-button">
                                    Add line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group v-for="(mail, i) in item.mails.chartering" v-bind:key="mail + i" class="array-input">
                            <b-form-input v-if="i > 0"
                                        aria-label="chartering mail"
                                        :value="item.mails.chartering[i]"
                                        @input="item.mails.chartering[i] = $event"
                                        required
                                        class="array-input"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append v-if="i > 0">
                                <b-button size="sm"
                                            @click="removeMailLine('chartering', i)" 
                                            class="mr-2 delete-button">
                                    Remove line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="item.name === 'Singapore'"
                                    label="Operation emails:"
                                    label-for="operations"
                                    invalid-feedback="At least one operations email is required. Provide them as coma separated values."
                                    :state="operationsState"
                                    label-cols="2">
                        <b-input-group>
                            <b-form-input id="operations"
                                        v-model="item.mails.operations[0]"
                                        required
                                        :state="operationsState"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm"
                                            @click="addNewMailsLine('operations')" 
                                            class="mr-2 edit-button">
                                    Add line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group v-for="(mail, i) in item.mails.operations" v-bind:key="mail + i" class="array-input">
                            <b-form-input v-if="i > 0"
                                        aria-label="operations mail"
                                        :value="item.mails.operations[i]"
                                        @input="item.mails.operations[i] = $event"
                                        required
                                        class="array-input"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append v-if="i > 0">
                                <b-button size="sm"
                                            @click="removeMailLine('operations', i)" 
                                            class="mr-2 delete-button">
                                    Remove line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="item.name === 'Singapore'"
                                    label="Admin emails:"
                                    label-for="admin"
                                    invalid-feedback="At least one admisistration & accounting email is required. Provide them as coma separated values."
                                    :state="adminState"
                                    label-cols="2">
                        <b-input-group>
                            <b-form-input id="admin"
                                        v-model="item.mails.admin[0]"
                                        required
                                        :state="adminState"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm"
                                            @click="addNewMailsLine('admin')" 
                                            class="mr-2 edit-button">
                                    Add line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group v-for="(mail, i) in item.mails.admin" v-bind:key="mail + i" class="array-input">
                            <b-form-input v-if="i > 0"
                                        aria-label="administration and accounting mail"
                                        :value="item.mails.admin[i]"
                                        @input="item.mails.admin[i] = $event"
                                        required
                                        class="array-input"
                                        size="sm"
                                        trim></b-form-input>
                            <b-input-group-append v-if="i > 0">
                                <b-button size="sm"
                                            @click="removeMailLine('admin', i)" 
                                            class="mr-2 delete-button">
                                    Remove line
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="item.name !== 'Singapore'"
                                    label="Email:"
                                    label-for="mail"
                                    invalid-feedback="Office email is required."
                                    :state="mailState"
                                    label-cols="2">
                        <b-form-input id="mail"
                                    v-model="item.mail"
                                    required
                                    :state="mailState"
                                    type="email"
                                    size="sm"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Coordinates:"
                                    label-for="position"
                                    invalid-feedback="Office coordinates are required. Please provide them as coma separated values."
                                    :state="positionState"
                                    label-cols="2">
                        <b-form-input id="position"
                                    v-model="item.position"
                                    required
                                    :state="positionState"
                                    size="sm"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="item.name !== 'Singapore'"
                                    label="Order number:"
                                    label-for="orderId"
                                    invalid-feedback="Order number should be greater than 0."
                                    :state="orderState"
                                    label-cols="2">
                        <b-form-input id="orderId"
                                    v-model="item.orderId"
                                    required
                                    :state="orderState"
                                    type="number"
                                    size="sm"
                                    trim></b-form-input>
                    </b-form-group>
                </form>
            </b-overlay>
        </b-modal>

        <b-modal ref="confirmDelete" 
                 :no-close-on-backdrop="true"
                 title="Delete office location"
                 @close="onPopupClose"
                 @ok="onConfirmDelete"
                 @cancel="onPopupCancel">
            <p v-if="item">
                Are you sure you want to delete <strong>"{{ item.name }}"</strong> from database?
            </p>
        </b-modal>
    </div>
</template>

<script>
import { doc, deleteDoc, updateDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";

export default {
    name: "EditContacts",
    data() {
        return {
            inEditing: false,
            updating: false,
            fields: [ { key: 'orderId', label: 'Order' }, 'name', 'telephone', 'fax', 'mail', 'edit' ],
            item: null
        }
    },
    computed: {
        loading() {
            return this.inEditing || !this.items || this.items.length === 0;
        },
        items() {
            return this.$store.state.contacts;
        },
        rows() {
            return this.items.length;
        },
        sortedItems() {
            return this.items.slice().sort((a, b) => { return a.orderId - b.orderId });
        },
        addressState() {
            return this.item.address.length > 1 && this.item.address[0].length > 1;
        },
        nameState() {
            return this.item.name.length > 1 ? true : false;
        },
        mailState() {
            return !!this.item.mail && !!this.item.mail.toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        charteringState() {
            return this.item.mails.chartering.length > 0 && !!this.item.mails.chartering[0].toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        operationsState() {
            return this.item.mails.operations.length > 0 && !!this.item.mails.operations[0].toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        adminState() {
            return this.item.mails.admin.length > 0 && !!this.item.mails.admin[0].toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        positionState() {
            let array = this.item.position.split(','),
                lat = array[0],
                lon = array[1];

            if (!!lat && !!lon) {
                lat = Number(lat);
                lon = Number(lon);

                return lat >= -180 && lat <= 180 && lon >= -180 && lon <= 180;
            } else {
                return false;
            }
        },
        orderState() {
            return this.item.orderId > 0 ? true : false;
        }
    },
    methods: {
        editItem(item) {
            if (item && this.editPopup) {
                this.item = JSON.parse(JSON.stringify(item));
                this.editPopup.show();
            }
        },
        deleteItem(item) {
            if (item && this.confirmDelete) {
                this.item = item;
                this.confirmDelete.show();
            }
        },
        async onConfirmDelete() {
            let index;

            if (this.item) {
                try {
                    this.inEditing = true;

                    await deleteDoc(doc(db, "contacts", this.item.id));

                    index = this.items.findIndex(item => item.id === this.item.id);
                    this.items.splice(index, 1);

                    alert(this.item.name + " successfully deleted.");
                    this.item = null;
                } catch {
                    alert("Office location delete failed.");
                } finally {
                    this.inEditing = false;
                }
            }
        },
        async onEditSave(e) {
            e.preventDefault();

            let valid = this.item && this.nameState && this.addressState && this.positionState;

            if (valid && this.item.name === 'Singapore') {
                valid = this.charteringState && this.operationsState && this.adminState;
            } else if (valid) {
                valid = this.orderState && this.mailState;
            }

            if (valid) {
                let id = this.item.id,
                    docRef, index, clone;

                this.updating = true;
                this.item.orderId = Number(this.item.orderId);

                if (id) {
                    // update item
                    try {
                        clone = Object.assign({}, this.item);
                        delete clone.id;

                        docRef = doc(db, "contacts", id);
                        await updateDoc(docRef, clone);

                        index = this.items.findIndex(item => item.id === id);
                        this.$set(this.items, index, JSON.parse(JSON.stringify(this.item)));

                        alert(this.item.name + " successfully updated.");
                        this.item = null;
                        this.editPopup.hide();
                    } catch (e) {
                        alert("Contacts update failed.");
                    } finally {
                        this.updating = false;
                    }
                } else {
                    // create item
                    try {
                        docRef = doc(db, "contacts", this.item.name);

                        await setDoc(docRef, this.item);

                        this.item.id = docRef.id;

                        this.items.push(JSON.parse(JSON.stringify(this.item)));

                        alert(this.item.name + " successfully created.");

                        this.item = null;
                        this.editPopup.hide();
                    } catch {
                        alert("Contacts create failed.");
                    } finally {
                        this.updating = false;
                    }
                }
            } else {
                alert('Name, Address, Mail, and Coordinates.')
            }
        },
        onPopupClose() {
            this.item = null;
            this.logoFile = null;
        },
        onPopupCancel() {
            this.item = null;
            this.logoFile = null;
        },
        addNewLine(field) {
            this.item[field].push('');
        },
        addNewMailsLine(field) {
            this.item.mails[field].push('');
        },
        removeLine(field, index) {
            this.item[field].splice(index, 1);
        },
        removeMailLine(field, index) {
            this.item.mails[field].splice(index, 1);
        },
        onAddNew() {
            this.editItem({
                orderId: 10, 
                name: '',
                fax: '', 
                mail: '',
                position: '',
                telephone: [''],
                address: ['']
            });
        }
    },
    
    mounted() {
        if (!auth.currentUser) {
            this.$router.push('/admin');
        }

        this.editPopup = this.$refs['editPopup'];
        this.confirmDelete = this.$refs['confirmDelete'];
    }
}
</script>

<style scoped>
    .array-input {
        margin-top: 0.2em;
    }
</style>